var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CreatorBtn",on:{"click":_vm.click}},[_c('div',{staticClass:"btn-item",class:_vm.type,style:({
        borderRadius: _vm.radius,
        width: _vm.width,
        height: _vm.height,
        fontSize: _vm.fontSize,
      })},[_vm._t("icon"),_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }